// extracted by mini-css-extract-plugin
module.exports = {"sound":"Player_sound__1apnh","soundIcon":"Player_soundIcon__3W1uK","isPaused":"Player_isPaused__2wocF"};